import { localhostRoute } from './localhost-route'

export function viewerRoute() {
  if (window.location.hostname === "localhost") {
    return localhostRoute().viewer;
  } else {
    return window.location.protocol + "//" + window.location.hostname + "/viewer";
  }
}